export function shortenWallet(str: string) {
    return `${str.slice(0, 5)}...${str.slice(-5)}`
}